// dataviz 스킬의 validated categorical palette를 그대로 사용합니다.
// (Anthropic dataviz skill / references/palette.md 기준, 2026-08 스냅샷)
// 순서를 바꾸지 마세요 — 인접 시리즈 간 색약(CVD) 구분 안전성이 이 "슬롯 순서"에 의존합니다.
// 브랜드 팔레트로 교체할 경우, node scripts/validate_palette.js 로 재검증한 값으로만 바꾸세요.
export const CATEGORICAL_PALETTE = [
  { light: '#2a78d6', dark: '#3987e5' }, // 1 blue
  { light: '#eb6834', dark: '#d95926' }, // 2 orange
  { light: '#1baf7a', dark: '#199e70' }, // 3 aqua
  { light: '#eda100', dark: '#c98500' }, // 4 yellow
  { light: '#e87ba4', dark: '#d55181' }, // 5 magenta
  { light: '#008300', dark: '#008300' }, // 6 green
  { light: '#4a3aa7', dark: '#9085e9' }, // 7 violet
  { light: '#e34948', dark: '#e66767' }, // 8 red
]

export function paletteColor(slotIndex, isDark) {
  const slot = CATEGORICAL_PALETTE[slotIndex % CATEGORICAL_PALETTE.length]
  return isDark ? slot.dark : slot.light
}

// 차트 크롬(축/그리드/텍스트) 토큰 — light/dark 각각 이 값만 스왑하면 됩니다.
export const CHART_CHROME = {
  light: {
    surface: '#fcfcfb',
    textPrimary: '#0b0b0b',
    textSecondary: '#52514e',
    muted: '#898781',
    grid: '#e1e0d9',
    axis: '#c3c2b7',
  },
  dark: {
    surface: '#1a1a19',
    textPrimary: '#ffffff',
    textSecondary: '#c3c2b7',
    muted: '#898781',
    grid: '#2c2c2a',
    axis: '#383835',
  },
}
